import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Button from '../ui/Button';
import SystemLines from '../ui/SystemLines';
import Reveal from '../ui/Reveal';

export default function Hero() {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 1000], [0, 200]);
  const opacity = useTransform(scrollY, [0, 500], [1, 0]);

  const bookSession = () => {
    window.open('https://topmate.io/mugdha_clarity90/2028348', '_blank');
  };

  const goToAudit = () => {
    window.open('/diagnostic', '_blank');
  };

  return (
    <section className="relative min-h-screen bg-brand-deep text-brand-cream flex items-center pt-20 overflow-hidden">
      <SystemLines />

      <motion.div style={{ y: y1, opacity }} className="max-w-7xl mx-auto px-6 md:px-12 w-full relative z-10">
        <div className="grid md:grid-cols-12 gap-8 md:gap-16 items-center">
          <div className="md:col-span-8">
            <Reveal>
              <h1 className="font-serif text-5xl md:text-7xl leading-[1.1] text-balance mb-8">
                You have a team. You're still doing everything yourself. <br />
                <span className="text-brand-sand">Start with the diagnosis. Everything else follows.</span>
              </h1>
            </Reveal>

            <Reveal delay={0.2}>
              <p className="text-lg md:text-xl text-brand-cream/80 max-w-2xl mb-12 font-light leading-relaxed">
                I work with founders who are doing everything right but growing too slowly. I find what's quietly blocking growth and build the operating system to remove it. In 90 days.
              </p>
            </Reveal>

            <Reveal delay={0.4}>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button onClick={bookSession}>
                  Book a Clarity Session
                </Button>
                <Button variant="secondary" onClick={goToAudit}>
                  Not sure where you're stuck? Take the free audit.
                </Button>
              </div>
            </Reveal>

            <Reveal delay={0.6}>
              <div className="mt-12 pt-8 border-t border-brand-cream/10">
                <p className="text-sm tracking-widest uppercase text-brand-sand">Mugdha Yelkar</p>
                <p className="text-brand-cream/60">Fractional COO | Creator of Clarity90</p>
              </div>
            </Reveal>
          </div>
        </div>
      </motion.div>

      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-brand-cream to-transparent z-20" />
    </section>
  );
}